/* Top Of Mind — global.js
 *
 * Behaviour only. No product names, prices or copy live in this file; the
 * Lovable build's global.js hardcoded a NAMES map that broke silently whenever
 * a product was renamed, and that is a documented counter-pattern.
 *
 * Everything is delegated from document so section re-renders in the theme
 * editor keep working without re-binding.
 */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- header */

  var header = null;

  function syncHeaderScroll() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 12);
  }

  function initHeader() {
    header = document.querySelector('[data-tom-header]');
    if (!header) return;
    syncHeaderScroll();
  }

  window.addEventListener('scroll', syncHeaderScroll, { passive: true });

  /* --------------------------------------------------------------- drawer */

  function setDrawer(open) {
    var drawer = document.querySelector('[data-tom-drawer]');
    var trigger = document.querySelector('[data-tom-drawer-open]');
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.hidden = !open;
    document.body.style.overflow = open ? 'hidden' : '';
    if (trigger) trigger.setAttribute('aria-expanded', String(open));
  }

  /* --------------------------------------------------------------- search */

  function toggleSearch() {
    var panel = document.querySelector('[data-tom-search-panel]');
    var trigger = document.querySelector('[data-tom-search-toggle]');
    if (!panel) return;
    var open = !panel.classList.contains('is-open');
    panel.classList.toggle('is-open', open);
    if (trigger) trigger.setAttribute('aria-expanded', String(open));
    if (open) {
      var field = panel.querySelector('input[name="q"]');
      if (field) field.focus();
    }
  }

  /* ------------------------------------------------------------ delegation */

  document.addEventListener('click', function (event) {
    var el = event.target.closest(
      '[data-tom-drawer-open],[data-tom-drawer-close],[data-tom-search-toggle],[data-tom-accordion-trigger],[data-tom-qty],[data-tom-gallery-thumb],[data-tom-filter]'
    );
    if (!el) return;

    if (el.hasAttribute('data-tom-drawer-open')) return setDrawer(true);
    if (el.hasAttribute('data-tom-drawer-close')) return setDrawer(false);
    if (el.hasAttribute('data-tom-search-toggle')) return toggleSearch();

    if (el.hasAttribute('data-tom-accordion-trigger')) {
      var item = el.closest('[data-tom-accordion-item]');
      if (!item) return;
      var isOpen = item.hasAttribute('open');
      el.setAttribute('aria-expanded', String(!isOpen));
      return;
    }

    if (el.hasAttribute('data-tom-qty')) {
      var input = document.querySelector('[data-tom-qty-input]');
      if (!input) return;
      var step = el.getAttribute('data-tom-qty') === 'up' ? 1 : -1;
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var max = parseInt(input.getAttribute('max') || '10', 10);
      var next = (parseInt(input.value, 10) || min) + step;
      input.value = Math.min(max, Math.max(min, next));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    if (el.hasAttribute('data-tom-gallery-thumb')) {
      event.preventDefault();
      var main = document.querySelector('[data-tom-gallery-main]');
      var src = el.getAttribute('data-full');
      var srcset = el.getAttribute('data-srcset');
      if (main && src) {
        main.setAttribute('src', src);
        if (srcset) main.setAttribute('srcset', srcset);
      }
      document.querySelectorAll('[data-tom-gallery-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t === el);
        t.setAttribute('aria-current', t === el ? 'true' : 'false');
      });
      return;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setDrawer(false);
  });

  /* ----------------------------------------------------- variant selection */

  /* Reads the option buttons on the product form, finds the matching variant
   * in the JSON blob the section renders, and updates the hidden id input,
   * the price and the submit button. Nothing here assumes a fixed option
   * count, so a merchant adding a second option does not break it. */

  function initVariantPickers(scope) {
    (scope || document).querySelectorAll('[data-tom-variant-picker]').forEach(function (picker) {
      var dataEl = picker.querySelector('[data-tom-variant-data]');
      if (!dataEl) return;

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      var form = picker.closest('form') || document.querySelector('[data-tom-product-form]');
      var idInput = picker.querySelector('[data-tom-variant-id]');
      var priceEl = picker.querySelector('[data-tom-price]');
      var submitEl = picker.querySelector('[data-tom-submit]');
      var submitLabel = picker.querySelector('[data-tom-submit-label]');

      function currentOptions() {
        var selected = picker.querySelectorAll('[data-tom-option]:checked');
        return Array.prototype.map.call(selected, function (i) { return i.value; });
      }

      function update() {
        var opts = currentOptions();
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });

        if (idInput) idInput.value = match ? match.id : '';
        if (priceEl && match) priceEl.innerHTML = match.price_formatted;

        if (submitEl) {
          var unavailable = !match || !match.available;
          submitEl.disabled = unavailable;
          if (submitLabel) {
            submitLabel.textContent = !match
              ? submitEl.getAttribute('data-label-unavailable')
              : match.available
                ? submitEl.getAttribute('data-label-add')
                : submitEl.getAttribute('data-label-soldout');
          }
        }
      }

      picker.addEventListener('change', function (event) {
        if (event.target.matches('[data-tom-option]')) update();
      });

      if (form) form.addEventListener('change', update);
      update();
    });
  }

  /* ---------------------------------------------------------- collection */

  /* Client-side chip filter for the shop grid. Progressive: the links are real
   * collection URLs, so this only intercepts when JS is available. */

  function initInit() {
    initHeader();
    initVariantPickers(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInit);
  } else {
    initInit();
  }

  /* Theme editor hooks so sections stay interactive after a re-render. */
  document.addEventListener('shopify:section:load', function (event) {
    initHeader();
    initVariantPickers(event.target);
  });
})();
